export default __webpack_public_path__ + "static/media/FinanceRealCase2-mobile-sc.71ad25be.jpg";